import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSenchaComponent } from './simple-icons-sencha.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSenchaComponent ],
    exports:      [ SimpleIconsSenchaComponent ],
    bootstrap:    []
})
export class SimpleIconsSenchaModule {}
